import { MindyDocRoles } from '@quadminds/mindy-shared';
import { IAuthMeV2OutputDto, IUserOutputDto } from '@quadminds/shared/auth-system';
import { useQueryClient } from '@tanstack/react-query';

export const useIsKnowledge = () => {
    const queryClient = useQueryClient();
    const userInfo: IAuthMeV2OutputDto | undefined = queryClient.getQueryData(['userInfo']);
    const currentOrganizationId = userInfo?.currentOrganization;
    const organizationUser =
        currentOrganizationId && userInfo?.id
            ? queryClient.getQueryData<IUserOutputDto>(['organizationUserById', currentOrganizationId, userInfo.id])
            : undefined;

    const knowledgeRoles = [MindyDocRoles.ADMIN_DOC, MindyDocRoles.MANAGER_DOC, MindyDocRoles.CONSULTANT_DOC];

    const organizationRoles = currentOrganizationId
        ? organizationUser?.userOrganizations
              ?.find((organization) => organization.organization === currentOrganizationId)
              ?.roles?.map((role) => role.name)
        : undefined;

    const rolesToEvaluate = organizationRoles ?? userInfo?.roles ?? [];
    const isKnowledge = rolesToEvaluate.some((role) => knowledgeRoles.includes(role as MindyDocRoles));

    return { isKnowledge: !!isKnowledge, isLoading: false };
};
